<template>
  <div class="animated fadeIn h-100 m-4">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-industry"/> Groups <CButton @click="newGroup()" color="info" class="m-0 float-right" size="sm" v-bind="{shape: 'pill'}">New group</CButton>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              hover="hover"
              striped="striped"
              bordered="bordered"
              small="small"
              fixed="fixed"
              :items="groups"
              :fields="fields"
              :items-per-page="25"
              pagination
              table-filter
            >
              <template #name="{item}"><td><CLink @click="editGroup(item, false)">{{item.name}}</CLink></td></template>
              <template #parentname="{item}"><td><CLink @click="editGroup(item, true)" v-if="item.parentid!='00000000-0000-0000-0000-000000000000'">{{item.parentname}}</CLink></td></template>
              <template #description="{item}"><td>{{item.description == null ? '' : item.description}}</td></template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal :title="modalTitle" color="dark" size="lg" :centered="true" :closeOnBackdrop="false" :show.sync="addGroupModal">
      <CSelect label="Parent Group" :options="groupParentOptions" :value.sync="groupParent" :disabled="groupParentOptions.length == 1" />
      <CInput label="Group Name" placeholder="Enter group name" v-model="groupName" />
      <CInput label="Description" placeholder="Enter description" v-model="groupDescription" />

      <template #footer>
        <CButton v-if="role == 'super' || (groupParent != '00000000-0000-0000-0000-000000000000' && role == 'admin')" @click="deleteGroup" color="danger" class="mr-auto">Delete group</CButton>
        <CButton @click="addGroupModal = false" color="secondary ">Cancel</CButton>
        <CButton @click="saveGroup" color="success" :disabled="groupName == '' " >Save</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Vue from 'vue'
import { telemetry } from '@/api'

export default {
  name: 'Groups',
  components: {

  },
  data () {
    return {
      addGroupModal: false,
      groupId: null,
      groupParent: null,
      groupName: '',
      groupDescription: '',
      groupParentOptions: [],
      modalTitle: '',
      fields: [{key: 'name', label: 'Group'},{key:'parentname', label: 'Parent Group'},{key:'description', label: 'Description'}]
    }
  },
  mounted () {
    this.loadGroups()
  },
  computed: {
    role() {
      return localStorage.role
    },
    groups() {
      return this.$store.state.groups
    }
  },
  methods: {
    loadGroups() {
      this.$store.dispatch("loadGroups")
    },
    optionContains(options, value) {
      var found = false
      for(var i = 0; i < options.length; i++) {
        if (options[i].value == value) {
          found = true
          break
        }
      }
      return found
    },
    fillOptions(group) {
      this.groupParentOptions = []
      for(var idx=0; idx < this.groups.length; idx++) {
        let option = { value: this.groups[idx].parentid, label: this.groups[idx].parentname }
        if((option.value == '00000000-0000-0000-0000-000000000000' && localStorage.role == 'super') && !this.optionContains(this.groupParentOptions, option.value)) {
          this.groupParentOptions.push(option)
        }
        if(this.groups[idx].id != group) {
          option = { value: this.groups[idx].id, label: this.groups[idx].name }
          if(!this.optionContains(this.groupParentOptions, option.value)){
            this.groupParentOptions.push(option)
          }
        }
      }
    },
    editGroup(item, parent) {
      if(parent) {
        for(var idx=0; idx < this.groups.length; idx++) {
          if(this.groups[idx].id == item.parentid) {
            item = this.groups[idx]
            break
          }
        }
      }

      this.groupId = item.id
      if(item.parentid == '00000000-0000-0000-0000-000000000000' && localStorage.role != 'super') {
        this.groupParentOptions = [{ value: '00000000-0000-0000-0000-000000000000', label: '[Master Group]' }]
      } else {
        this.fillOptions(item.id)
      }
      this.groupParent = item.parentid
      this.groupName = item.name
      this.groupDescription = item.description
      this.modalTitle = 'Edit group'
      this.addGroupModal = true
    },
    saveGroup() {
      telemetry.updateGroup({id: this.groupId, name: this.groupName, description: this.groupDescription, parent: this.groupParent})
        .then(response => {
        this.$toasted.success('Group saved.')
        this.addGroupModal = false
        this.loadGroups()
      }).catch((error) => {
        this.$toasted.error('Unable to save group.')
      })
    },
    deleteGroup() {
      let ret = confirm('Are you sure you want to delete ' + this.groupName + "?")
      if(ret) {
          telemetry.deleteGroup(this.groupId).then(response => {
            console.log(response)
            if(response.data.status == 'ok') {
                this.$toasted.success('Group deleted.')
                this.addGroupModal = false
                this.loadGroups()
            } else {
                this.$toasted.error(response.data.message)
            }
          }).catch((error) => {
            this.$toasted.error(error)
          })
      }
    },
    newGroup() {
      this.fillOptions(null)
      this.groupParent = (this.groupParentOptions.length > 0 ? this.groupParentOptions[0].value : null)
      this.groupId = null
      this.groupName = ''
      this.groupDescription = ''
      this.modalTitle = 'New group'
      this.addGroupModal = true
    }
  }
}
</script>
